import { BaseContainerModel } from '../base-container.model';
import { bl_hc_patient_medical_test_consultation_link_RowClass, bl_hc_patient_medical_test_consultation_link_RowInterface } from '../../dbschema/bl_hc_patient_medical_test_consultation_link.model';


export class HcPatientMedicalTestConsultationLinkContainerModel extends BaseContainerModel {
  bl_hc_patient_medical_test_consultation_link: bl_hc_patient_medical_test_consultation_link_RowInterface = new bl_hc_patient_medical_test_consultation_link_RowClass();
}